/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Note_PlaceholderInputs */

const en_admin_invite_codes_note_placeholder = /** @type {(inputs: Admin_Invite_Codes_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional note for internal reference`)
};

/**
* | output |
* | --- |
* | "Optional note for internal reference" |
*
* @param {Admin_Invite_Codes_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_note_placeholder = /** @type {((inputs?: Admin_Invite_Codes_Note_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Note_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_note_placeholder(inputs)
});
export { admin_invite_codes_note_placeholder as "admin.invite_codes.note_placeholder" }